// extracted by mini-css-extract-plugin
export default {"buttonStyle":"CustomButtonDarkBg_buttonStyle__kFsUl"};